export default __webpack_public_path__ + "static/media/4T0A9767.fcb84a57.jpg";